import { Selectors3asFPermissions } from '@va/aaas/shared/selectors';
import { getApiRequest } from '@va/dashboard/selectors/api';
import { is3asApp, isWixMiniApp } from '@va/util/helpers';
import { WixPermissionPack, WixPlanCycle } from '@va/wix/shared/constants';

type FeatureLimit = {
  limit?: number;
};

type FeaturePermissions = {
  customDashboard?: boolean;
  countryBasedPrivacy?: boolean;
  visitorSegments?: boolean;
  unlimitedVoucher?: null | string;
  wixPermissionPack?: WixPermissionPack;
  wixCycleType?: WixPlanCycle;
  ip2company?: boolean;
  isPayable?: boolean;
  feedbackAdvertising?: boolean;

  recordings?: FeatureLimit;
  heatmaps?: FeatureLimit;
  visits?: FeatureLimit;
  apiKeys?: FeatureLimit;
  eventTracking?: FeatureLimit;
  polls?: FeatureLimit;
  surveys?: FeatureLimit;
  funnels?: FeatureLimit;
};

export const isCompanyRevealFeatureEnabled = (state: any) => {
  if (is3asApp()) {
    return Selectors3asFPermissions.isEnabled.ipToCompany(state);
  }

  const featurePermissions = getFeaturePermissions(state) as FeaturePermissions;
  return !!featurePermissions.ip2company;
};

export const isVisitorSegmentsFeatureEnabled = (state: any) => {
  if (is3asApp()) {
    return Selectors3asFPermissions.isEnabled.visitorSegments(state);
  }
  const featurePermissions = getFeaturePermissions(state) as FeaturePermissions;
  return !!featurePermissions.visitorSegments;
};

export const isCountryBasedPrivacyModeEnabled = (state: any) => {
  if (is3asApp() || isWixMiniApp()) {
    return Selectors3asFPermissions.isEnabled.countryBasedPrivacy(state);
  }

  const featurePermissions = getFeaturePermissions(state) as FeaturePermissions;
  return !!featurePermissions.countryBasedPrivacy;
};

export const isCustomDashboardFeatureEnabled = (state: any) => {
  if (is3asApp()) {
    return Selectors3asFPermissions.isEnabled.customDashboards(state);
  }

  const featurePermissions = getFeaturePermissions(state) as FeaturePermissions;
  return !!featurePermissions.customDashboard;
};

export const isFeedbackAdvertisingFeatureEnabled = (state: any) => {
  if (is3asApp()) {
    // Option is not visible in 3as
    return false;
  }

  const featurePermissions = getFeaturePermissions(state) as FeaturePermissions;
  return !!featurePermissions.feedbackAdvertising;
};

export const getFeaturePermissions = (state: any) => {
  return getApiRequest(state, 'getFeaturePermissions') as FeaturePermissions;
};
